import httpClient from "../apiClient";
import { TGetAllChargebacks, TGetAllRefundsRequest, TGetStripeChargesRequest } from "./index.types";

export class StripeAPI {
  static getStripeChargesRequest: TGetStripeChargesRequest = (body) =>
    httpClient.post("charges", body);
  static getAllRefundsRequest: TGetAllRefundsRequest = (body) => httpClient.post("refunds", body);
  static getAllChargebacks: TGetAllChargebacks = (body) => httpClient.post("chargebacks", body);
}
